import React, { useState } from 'react';
import CreateNewButton from '../CreateNewButton'
import DataProvider from '../../DataProvider.js'
import { EditCustomRedirectButton, ShowFromOrg } from './OrgButtons.js'
import './OrgPopup.css'


const OrgDTPopup = props => {
    const orgid = props.id
    const [admins, setAdmins] = useState(null)
    const [sortDirection, setSortDirection] = useState('ASC')

    function toggleSort(type) {
        let direction
        sortDirection === "ASC" ?  direction = "DESC" : direction = "ASC"
        setSortDirection(direction)
        getData('', '', { field: type, order: direction })
    }

    let divs = [<div class="pop-row no-hover">
        <div class="pop-row-section pop-row-section-header" onClick={() => toggleSort('firstName')}>First Name</div>
        <div class="pop-row-section pop-row-section-header" onClick={() => toggleSort('lastName')}>Last Name</div>
        <div class="pop-row-section pop-row-section-header" onClick={() => toggleSort('email')}>Email</div>
        <div class="pop-row-section pop-row-section-header"></div>
        <div class="pop-row-section pop-row-section-header"></div>
    </div>]
    const getData = async (firstName, lastName, sort) => {
        const data = await DataProvider.getList('users', { pagination: { page: 1, perPage: 10000000000 }, sort: sort, filter: { OrganizationUsers: orgid, firstName: firstName, lastName: lastName } })
        setAdmins([...data.data])
    }
    if (admins === null) getData('', '', { field: 'firstName', order: 'ASC' })
    else for (let admin of admins) {
        divs.push(
            <div class="pop-row" style={{ minWidth: '520px' }}>
                <div class="pop-row-section">{admin.firstName}</div>
                <div class="pop-row-section">{admin.lastName}</div>
                <div class="pop-row-section">{admin.email}</div>
                <div class="pop-row-section"><ShowFromOrg record={admin} orgID={props.id} buttonTitle='Show' path="users" search_id="organization_id" /></div>
                <div class="pop-row-section"><EditCustomRedirectButton edittype="users" ddorgid={props.id} record={admin} redirectorigin="Organizations" path="users" /></div>
            </div>)
    }
    return (<div>
        <div class="bg-overlay" onClick={props.onclickoutside} />
        <div class="org-popup">
            <div class="org-popup-title">
                Users
            </div>
            <div class="popup-filters">
                <input class="popup-filter" type="text" name="fname" placeholder="Filter First Name" onChange={(e) => getData(e.target.value, '', { field: 'firstName', order: 'ASC' })} />
                <input class="popup-filter" type="text" name="fname" placeholder="Filter Last Name" onChange={(e) => getData('', e.target.value, { field: 'lastName', order: 'ASC' })} />
            </div>
            <div class="popup-table">
                {divs}
            </div>
            <CreateNewButton orgID={parseInt(orgid)} search_id="organization_id" redirectorigin="Organizations" path="users" />
        </div>
    </div>)
}

export default OrgDTPopup